/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Web192029.css";

function Web192029(props) {
  const { x45943962354_929Ead0C96_K, group138, path128 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-29 screen">
        <div className="overlap-group1-6">
          <img className="x45943962354_929ead0c96_k" src={x45943962354_929Ead0C96_K} />
          <div className="rectangle-2-12 border-1px-dove-gray"></div>
          <div className="overlap-group-12">
            <div className="group-141">
              <div className="group-140">
                <div className="group-139">
                  <img className="group-138" src={group138} />
                </div>
              </div>
            </div>
            <img className="path-128" src={path128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web192029;
